import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Header from './Header';
import Sidebar from './Sidebar';

const MainLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const location = useLocation();
  const { user, logout } = useAuth();

  // Determine current view based on the current route
  const getCurrentView = () => {
    const path = location.pathname;
    if (path.startsWith('/dashboard')) return 'dashboard';
    if (path.startsWith('/clients')) return 'clients';
    if (path.startsWith('/services')) return 'services';
    if (path.startsWith('/contracts')) return 'contracts';
    if (path.startsWith('/templates')) return 'templates';
    if (path.startsWith('/bulk-contracts')) return 'bulk-contracts';
    if (path.startsWith('/standalone-acts')) return 'standalone-acts';
    if (path.startsWith('/settings')) return 'settings';
    return 'dashboard'; // default
  };

  const currentView = getCurrentView();

  const handleToggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const handleCloseMobileSidebar = () => {
    setMobileSidebarOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Mobile sidebar backdrop */}
      {mobileSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={handleCloseMobileSidebar}
        />
      )}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 lg:static lg:inset-0 transform transition-transform duration-300 ease-in-out lg:transform-none ${
        mobileSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      }`}>
        <Sidebar 
          currentView={currentView}
          collapsed={sidebarCollapsed}
          onCloseMobile={handleCloseMobileSidebar}
        />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <Header 
          user={user} 
          onLogout={logout}
          onToggleMobileSidebar={handleToggleMobileSidebar}
          mobileSidebarOpen={mobileSidebarOpen}
        />

        {/* Page content */}
        <main className="flex-1 overflow-auto">
          <div className="p-4 sm:p-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;